import { Component } from 'react'
import _ from 'lodash'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { Disclaimer } from '@vzmi/shp_shared_compo'
import { getFeatureToggle } from '@vzmi/component_ec_nodejs_util/dist/lib/FeatureToggleUtil'

import { Field, FormValueSelector } from '../../../../Common/forms'
import styles from './index.css'

import {
  FormRow,
  When,
  RFSelectInputField,
  WrappedFlatpickrInputField,
  TextareaCountField
} from '../../../../Common/Form'
import { DEADLINE_OPTIONS, getContactWindow } from '../../../Shared'
import { filterHtmlTag } from '../Shared/normalizers'
import Tip from '../../Tip'
import SingleLineText from '../../ReadOnlyComponents/SingleLineText/SingleLineText'
import withOptions from '../../ReadOnlyComponents/HOC/withOptions'
import MultiLineText from '../../ReadOnlyComponents/MultiLineText/MultiLineText'
import { ListingFieldConfig, getApplicantFieldProps } from '../Shared/FieldConfig'
import { getSupplierFullNameByUser, isNotPhaseOverview } from '../../../../../../lib/proposalHelper'

class ProposalInfo extends Component {
  constructor () {
    super()
    this.state = {
      contactWindow: ''
    }
  }

  componentDidMount () {
    const { user } = this.props
    const contactWindow = getContactWindow(user)
    this.setState({ contactWindow })
  }

  onSubStationChange = (props, value) => {
    const { change } = this.props
    // 目前只有書籍子站可以設定免稅，
    // 所以在切換 `提案站別／對象` 時需要重設預設值避免選擇其他子站後不能再調整免稅
    // https://jira.vzbuilders.com/browse/APACSMDESK-53585
    change('product.taxFree', false)
  }

  render () {
    const {
      subStationOptions,
      phase,
      supplierFullName,
      settingUser,
      readOnly,
      isNewProposal,
      mustShowFormError,
      flags
    } = this.props
    const { contactWindow } = this.state
    const identity = _.get(settingUser, 'identity', {})
    const isNotOverview = isNotPhaseOverview(phase)
    const expiredTsFlatpickrOptions = isNotOverview ? DEADLINE_OPTIONS : null
    const applicantFieldProps = getApplicantFieldProps((isNotOverview ? identity : {}), readOnly)
    const kaFeatureToggle = getFeatureToggle(flags, 'sp_KA')
    return (
      <div
        className={styles.ProposalInfo}
        data-role='proposal-info'
      >
        <FormRow
          key='supplierName'
          label='提案廠商'
        >
          <SingleLineText
            content={supplierFullName}
          />
        </FormRow>
        <FormRow
          key='applicant'
          label='提案人'
          withInputCountPaddingBottom={readOnly && !identity.isPM}
        >
          {/* 提案人
              只接受中文、最多10個中文字
              供應商登入: 空白顯示，由小幫手自行填寫
              模擬登入：空白顯示，由小幫手自行填寫
              PM 仿供應商登入：顯示該 PM 之中文姓名 (不提供修改)
              APACSMDESK-31338 提案人在最後送出提案時才真的變更為 PM if PM 編輯供應商之提案單 - FE
              APACSMDESK-32594 顯示PM名稱 */}
          <Field
            {...ListingFieldConfig.getField('applicant')}
            className={styles.applicant}
            {...applicantFieldProps}
            showErrorOnActive={isNewProposal}
            mustShowFormError={mustShowFormError}
          />
        </FormRow>
        <FormRow
          key='subStationId'
          label='提案站別／對象'
          contentClassName={styles.centerAlignContent}
        >
          <Field
            name='subStationId'
            data-role='subStationId'
            component={
              readOnly
                ? withOptions(SingleLineText)
                : RFSelectInputField
            }
            className={styles.subStationIdSelect}
            options={subStationOptions}
            showErrorOnActive={isNewProposal}
            mustShowFormError={mustShowFormError}
            onChange={this.onSubStationChange}
            simpleValue
          />
          {
            kaFeatureToggle && (
              <span className={styles.deadlineLabel}>
                &nbsp;/&nbsp;
                { contactWindow }
              </span>
            )
          }
        </FormRow>
        <FormRow
          key='expiredTsTip'
        >
          <Tip type='info'>可設定日期為提案日＋3~15天</Tip>
        </FormRow>
        <FormRow
          key='expiredTs'
          label='審核期限'
          style={{ marginTop: '4px' }}
          contentClassName={cx(
            styles.centerAlignContent,
            { [styles.readOnly]: readOnly }
          )}
        >
          <span className={styles.deadlineLabel}>請雅虎資訊於&nbsp;</span>
          <Field
            name='expiredTs'
            data-role='expiredTs'
            component={WrappedFlatpickrInputField}
            className={styles.deadlinePickr}
            enableCalender
            options={expiredTsFlatpickrOptions}
            showErrorOnActive={isNewProposal}
            mustShowFormError={mustShowFormError}
            readOnly={readOnly}
            textOnly={readOnly}
            alwaysIgnoreError={readOnly}
          >
            <span className={styles.deadlineLabel}>&nbsp;前審核完畢，如遇過期，提案人需重新提案</span>
          </Field>
        </FormRow>
        <FormRow
          key='note'
          label='提案備註'
          subTitle='(非必填)'
          withInputCountPaddingBottom
        >
          <Field
            name='note'
            data-role='note'
            component={
              readOnly
                ? MultiLineText
                : TextareaCountField
            }
            countLimit={200}
            className={styles.note}
            placeholder='如有提案注意事項需通知本公司PM，請填寫內容'
            normalizeOnBlur={filterHtmlTag}
            fullWidth
          />
        </FormRow>
        <When
          value={!readOnly}
          isTrue
        >
          <FormRow
            noLabel
            key='disclaimer'
          >
            <Disclaimer
              detailsVisible
            />
          </FormRow>
        </When>
      </div>
    )
  }
}

ProposalInfo.propTypes = {
  user: PropTypes.object,
  supplierFullName: PropTypes.string,
  readOnly: PropTypes.bool,
  subStationOptions: PropTypes.array
}

const ProposalInfoContainer = (props) => {
  return (
    <FormValueSelector
      selector={
        (select) => ({
          settingUser: select('setting.user'),
          phase: select('setting.phase'),
          readOnly: select('setting.readOnly'),
          subStationId: select('subStationId')
        })
      }
    >
      {
        values => {
          const { settingUser } = values
          const supplierFullName = getSupplierFullNameByUser(settingUser)
          return (
            <ProposalInfo
              {...props}
              {...values}
              settingUser={settingUser}
              supplierFullName={supplierFullName}
            />
          )
        }
      }
    </FormValueSelector>
  )
}

export default ProposalInfoContainer
